// Shared syntax token colors used by the Ace editor theme. Brand/base colors
// are inlined here so the token map is self-contained (enki's theme does not
// export `brand`/`base`).
const codeTokens = {
  keyword: '#c678dd',
  string: '#D2FF94', // brand.lime
  comment: '#71717A', // base.grayDark
  variable: '#e06c75',
  number: '#d19a66',
  constant: '#8BDADB', // brand.teal
  func: '#61afef',
  classType: '#e5c07b',
};

export default codeTokens;
